import { render, staticRenderFns } from "./WorkItemsModal.html?vue&type=template&id=33d6ff48&scoped=true&external"
import script from "./WorkItemsModal.ts?vue&type=script&lang=ts&external"
export * from "./WorkItemsModal.ts?vue&type=script&lang=ts&external"
import style0 from "./WorkItemsModal.css?vue&type=style&index=0&id=33d6ff48&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d6ff48",
  null
  
)

export default component.exports